<canvas
  #chartCanvas
  [style.--price-line-chart-height.px]="height"
  [class.animate-in]="animateIn"
></canvas>
